import firebase from 'firebase'

const url = window.location.host.split(':');

let config = false;

switch(url[0]) {
	case 'admin.mydp.smartceptation.nl':
	config = {
	   apiKey: "AIzaSyC3Y3q0h7vzgO-nRUgi-G7MRubniZj3Q70",
	    authDomain: "mijndp-smartceptation.firebaseapp.com",
	    databaseURL: "https://mijndp-smartceptation.firebaseio.com",
	    projectId: "mijndp-smartceptation",
	    storageBucket: "mijndp-smartceptation.appspot.com",
	    messagingSenderId: "375932267448"

	};
	break;
	case 'admin.mijndp.dp.nl':
		config = {
	    apiKey: "AIzaSyARffaRdOX51pm_br-FdmHFV9yDsu8teMU",
	    authDomain: "mijndp-production.firebaseapp.com",
	    databaseURL: "https://mijndp-production.firebaseio.com",
	    projectId: "mijndp-production",
	    storageBucket: "mijndp-production.appspot.com",
	    messagingSenderId: "844756791389"
	  };

	break;
	default:
		/*config = {
			apiKey: "AIzaSyD3oESisOn_ZasRLCd6WfTno5tqDYBzxjQ",
			authDomain: "mijndp-dev.firebaseapp.com",
			databaseURL: "https://mijndp-dev.firebaseio.com",
			projectId: "mijndp-dev",
			storageBucket: "mijndp-dev.appspot.com",
			messagingSenderId: "68481754457",
			appId: "1:68481754457:web:4d085b0c92b4d80769d848"

		};*/
		  config = {
  		   apiKey: "AIzaSyC3Y3q0h7vzgO-nRUgi-G7MRubniZj3Q70",
  		    authDomain: "mijndp-smartceptation.firebaseapp.com",
  		    databaseURL: "https://mijndp-smartceptation.firebaseio.com",
  		    projectId: "mijndp-smartceptation",
  		    storageBucket: "mijndp-smartceptation.appspot.com",
  		    messagingSenderId: "375932267448"

  		};



}

firebase.initializeApp(config);

export default firebase;



// WEBPACK FOOTER //
// ./src/components/Firebase/index.js